// src/pages/ValetDetails.js
import React, { useState } from 'react';

export default function ValetDetails({ valet }) {
  // Demo valet data if none provided
  const demoValet = {
    id: 101,
    name: 'Anna Brave',
    email: 'anna.brave@example.com',
    workingSince: '2023-01-01',
    shift: '9-5',
    salary: '$3000/month',
    reviews: [
      { id: 1, content: 'Great performance', rating: 5 },
      { id: 2, content: 'Very efficient', rating: 4 },
    ],
    tips: [
      { id: 1, amount: 15 },
      { id: 2, amount: 10 },
    ],
    pastRides: [
      { id: 1, car: 'Tesla Model 3', date: '2025-02-10', duration: '1h 30m' },
      { id: 2, car: 'Audi A4', date: '2025-02-12', duration: '2h 00m' },
    ]
  };

  const currentValet = demoValet;
  const [showSalary, setShowSalary] = useState(false);
  const [code, setCode] = useState('');

  const handleShowSalary = () => {
    // For demo, use "1234" as the correct code
    if (code === '1234') {
      setShowSalary(true);
    } else {
      alert('Incorrect code.');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ color: '#ba00ba', marginBottom: '20px' }}>Valet Details</h2>
      
      {/* Basic Information Card */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h3>{currentValet.name}</h3>
        <p><strong>Email:</strong> {currentValet.email}</p>
        <p><strong>Working Since:</strong> {new Date(currentValet.workingSince).toLocaleDateString()}</p>
        <p><strong>Shift:</strong> {currentValet.shift}</p>
        {showSalary ? (
          <p><strong>Salary:</strong> {currentValet.salary}</p>
        ) : (
          <div style={{ marginTop: '10px' }}>
            <input
              type="password"
              placeholder="Enter code to view salary"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              style={{
                padding: '8px',
                marginRight: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
            />
            <button
              onClick={handleShowSalary}
              style={{
                background: '#ba00ba',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                padding: '8px 16px',
                cursor: 'pointer'
              }}
            >
              Show Salary
            </button>
          </div>
        )}
      </div>

      {/* Reviews Table */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '10px' }}>Reviews</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>Review</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Rating</th>
            </tr>
          </thead>
          <tbody>
            {currentValet.reviews.map((review) => (
              <tr key={review.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '8px' }}>{review.content}</td>
                <td style={{ padding: '8px' }}>{review.rating} / 5</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Tips Table */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '10px' }}>Tips</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {currentValet.tips.map((tip) => (
              <tr key={tip.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '8px' }}>${tip.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Past Rides Table */}
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '10px' }}>Past Rides</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>Car</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Date</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Duration</th>
            </tr>
          </thead>
          <tbody>
            {currentValet.pastRides.map((ride) => (
              <tr key={ride.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '8px' }}>{ride.car}</td>
                <td style={{ padding: '8px' }}>{new Date(ride.date).toLocaleDateString()}</td>
                <td style={{ padding: '8px' }}>{ride.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
